<template>
  <DragDialog
    title="属性对比结果"
    :width="480"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div
      class="loading-box"
      v-if="isLoading">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      class="result-box"
      v-else>
      <div class="header-box">
        <div class="count-box">
          <span class="public-tips-primary">有</span>
          <span class="count">{{ count }}</span>
          <span class="public-tips-primary">处属性变更</span>
        </div>
        <div class="legend-box">
          <div class="item-box attr-add">
            <div class="circle-box bg-color1" />
            <div>属性新增</div>
          </div>
          <div class="item-box attr-delete">
            <div class="circle-box bg-color2" />
            <div>属性删除</div>
          </div>
          <div class="item-box attr-modify">
            <div class="circle-box bg-color3" />
            <div>属性修改</div>
          </div>
        </div>
      </div>
      <div class="table-box">
        <div class="table-header-box">
          <div class="td">属性</div>
          <div class="td">变更前</div>
          <div class="td">变更后</div>
        </div>
        <div class="tbody-box">
          <div
            class="attr-box"
            v-for="(item, index) in attrList"
            :key="index">
            <div class="sub-header-box">{{ item.group }}</div>
            <div
              :class="getTrClassName(attr)"
              v-for="(attr, attrIndex) in item.data"
              :key="attrIndex">
              <div class="td">{{ attr.paramName }}</div>
              <div :class="getClassName(attr, 'old')">
                {{ attr.oldValue ? attr.oldValue : '--' }}
                {{ attr.oldValue ? attr.oldUnitType : '' }}
              </div>
              <div :class="getClassName(attr, 'new')">
                {{ attr.newValue ? attr.newValue : '--' }}
                {{ attr.newValue ? attr.newUnitType : '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="exception-legend-box"
        v-if="isLegendVisible">
        <div class="icon-box" />
        <div class="text-box public-tips-primary">属性名称重复</div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import Spin from '@/components/Spin.vue'

import { getParamsContrastResultService } from '@/service/interface'

export default {
  data() {
    return {
      isLoading: false,

      count: 0,

      attrList: [],

      isLegendVisible: false
    }
  },
  props: {
    visible: Boolean,
    elemInfo: Object,
    closeDialog: Function
  },
  components: {
    DragDialog,
    Spin
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initParamsContrastResult()
      }
    }
  },
  methods: {
    initParamsContrastResult() {
      this.isLoading = true
      this.queryParamsContrastResult().then(attrList => {
        this.attrList = attrList

        this.isLoading = false
      })
    },
    cancel() {
      this.count = 0
      this.attrList = []
      this.isLegendVisible = false

      this.closeDialog()
    },
    getClassName(attr, attrType) {
      let className = 'td test-overflow'
      if (attrType === 'old') {
        className += attr.dataType === 1 ? ' attr-delete' : ''
      }

      if (attrType === 'new') {
        className += attr.dataType === 0 ? ' attr-add' : ''
        className += attr.dataType === 2 ? ' attr-modify' : ''
      }
      return className
    },
    getTrClassName(attr) {
      let className = 'tr'
      if (attr.dataType === 4) {
        className += attr.dataType === 4 ? ' abnormal-bg' : ''
        this.isLegendVisible = true
      } else {
        className += attr.dataType === 4 ? ' normal-bg' : ''
      }

      return className
    },
    queryParamsContrastResult() {
      return new Promise(resolve => {
        let { dataSetId, fromVersion, toVersion } = this.$route.query
        let elemIntId = this.elemInfo.elemIntId
        let params = {
          dataSetId,
          fromVersion: Number(fromVersion),
          toVersion: Number(toVersion),
          elemIntId
        }
        getParamsContrastResultService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data

            let attrList = data ? data.projectParam : []
            this.count = data ? data.changeCount : 0
            resolve(attrList)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.loading-box {
  position: relative;
  height: 500px;
}

.header-box {
  display: flex;
  justify-content: space-between;
  font-size: 12px;

  .count-box {
    color: #e2e2e2;

    .count {
      margin: 0px 5px;
      color: var(--base-primary-bgColor);
    }
  }

  .legend-box {
    display: flex;

    .attr-add {
      color: #2ac496;
    }

    .attr-delete {
      color: #ff3232;
    }

    .attr-modify {
      color: #ec9d00;
    }

    .item-box {
      display: flex;
      margin-right: 25px;

      &:last-child {
        margin-right: 0px;
      }

      .circle-box {
        width: 5px;
        height: 5px;
        margin: auto 6px auto 0px;
        border-radius: 50%;
      }

      .bg-color1 {
        background: #2ac496;
      }

      .bg-color2 {
        background: #ff3232;
      }

      .bg-color3 {
        background: #ec9d00;
      }
    }
  }
}

.table-box {
  margin-top: 15px;
  color: #e2e2e2;
  font-size: 12px;
  text-align: left;
  border: 1px solid var(--base-border-dark-color14);

  .table-header-box {
    display: flex;
    padding: 16px 25px;
    background: var(--base-bg-dark-color35);
    border-bottom: 1px solid var(--base-border-dark-color14);

    .td {
      width: 132px;
      padding: 0px 10px;
      color: var(--bim-ver-eng-table-header-text-color);
      font-size: 14px;

      &:first-child {
        padding: 0px;
      }
    }
  }

  .tbody-box {
    height: 450px;
    overflow-y: auto;
    overflow-x: hidden;

    .sub-header-box {
      padding: 15px 25px;
      background: var(--base-bg-dark-color33);
      border-bottom: 1px solid var(--base-border-dark-color14);
      color: var(--bim-ver-eng-table-header-text-color);
    }

    .normal-bg {
      background: #252525;
    }

    .abnormal-bg {
      background: var(--bim-ver-eng-table-abnormal-bg-color);

      .td {
        color: var(--bim-ver-eng-table-abnormal-text-color);
      }
    }

    .tr {
      display: flex;
      padding: 15px 25px;
      border-bottom: 1px solid var(--base-border-dark-color14);
      color: var(--bim-ver-eng-table-body-text-color);

      .td {
        width: 132px;
        word-break: break-all;
        padding: 0px 10px;
      }

      .attr-add {
        color: #2ac496;
      }

      .attr-delete {
        color: #ff3232;
      }

      .attr-modify {
        color: #ec9d00;
      }
    }

    .attr-box:last-child {
      .tr:last-child {
        border-bottom: none;
      }
    }
  }
}

.exception-legend-box {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding-top: 16px;
  padding-left: 16px;
  border-top: 1px solid var(--base-border-dark-color14);
  width: calc(100% + 32px);
  margin-left: -16px;
  .icon-box {
    width: 20px;
    height: 15px;
    background: var(--bim-ver-eng-table-abnormal-bg-color);
  }

  .text-box {
    margin-left: 15px;
  }
}
</style>
